import $ from "jquery";
import deps from "../../../../assets/js/lib/dependencies";

const Flickity = deps.flickity;

// `medium` uit `_settings.scss`. Onder die grens is het blok een slider, erboven een lijst met
// rijen — dus Flickity wordt daar afgebroken in plaats van verborgen, anders blijven de cellen
// absoluut gepositioneerd staan.
const IS_MOBILE = window.matchMedia("(max-width: 799px)");

/**
 * Mark the cards whose description is cut off by the mobile clamp
 *
 * Alleen die kaarten krijgen "Lees meer". Of een tekst afgekapt wordt hangt aan de regelval en dus
 * aan de kaartbreedte, vandaar meten in plaats van een tekenlimiet. Een opengeklapte kaart houdt
 * zijn knop, anders kan hij niet meer dicht.
 */
function markClampedTexts(container) {
    $(container)
        .find(".sb_accommodation-item")
        .not(".s_is-expanded")
        .each(function () {
            const text = this.querySelector("[data-accommodation-text]");

            $(this).toggleClass(
                "s_has-more",
                Boolean(text) &&
                    IS_MOBILE.matches &&
                    text.scrollHeight > text.clientHeight + 1
            );
        });
}

/**
 * Init or destroy the slider for one items container, following the breakpoint
 */
function syncSlider(container) {
    const existing = Flickity.data(container);

    // Vóór het gelijktrekken van de kaarthoogtes: de knop telt mee in de hoogte van de kaart.
    markClampedTexts(container);

    if (!IS_MOBILE.matches) {
        if (existing) {
            existing.destroy();
        }

        // `slider-card-heights.js` schrijft een `min-height` op de kortere kaarten. Zonder deze
        // regel houden de rijen op desktop de hoogte van de hoogste mobiele kaart vast.
        $(container).find(".sb_accommodation-item").css("min-height", "");

        return;
    }

    if (existing) {
        existing.resize();
        $(document).trigger("slider-cards:measure");
        return;
    }

    // Eén accommodatie is geen slider.
    if (container.children.length < 2) {
        return;
    }

    const settings = JSON.parse(
        container.getAttribute("data-flickity-settings")
    );

    new Flickity(container, settings);

    $(container)
        .on("dragStart.flickity", () => $(container).addClass("s_is-dragging"))
        .on("dragEnd.flickity", () => $(container).removeClass("s_is-dragging"));

    // De kaarthoogte hangt aan de tekst, dus die valt niet met CSS gelijk te zetten — zie de
    // toelichting in `slider-card-heights.js`.
    $(document).trigger("slider-cards:measure");
}

/**
 * On click on the toggle — show or hide the accommodations beyond the visible rows
 *
 * Elke lookup blijft binnen de sectie waar de knop bij hoort: de kitchensink zet meerdere blokken
 * op één pagina, en een paginabrede selector zou ze allemaal tegelijk omklappen.
 */
$("[data-accommodations-toggle]").on("click tap", function () {
    const $items = $(this)
        .closest('[data-s-type="template-accommodations"]')
        .find("[data-accommodations-items]");
    const isCollapsed = $items.hasClass("s_is-collapsed");

    $items.toggleClass("s_is-collapsed");

    $(this)
        .find(".sb_template-accommodations_more_label")
        .text(
            isCollapsed
                ? $(this).data("accommodations-collapse-text")
                : $(this).data("accommodations-expand-text")
        );

    $(this).find(".sb_icon-plusmin").toggleClass("s_is-open", isCollapsed);
});

/**
 * On click on "Lees meer" — open or close the description of one card
 *
 * Een geopende kaart doet niet mee met het gelijktrekken van de hoogtes (zie
 * `slider-card-heights.js`), dus de rest van de rij blijft even hoog en alleen de Flickity-viewport
 * groeit mee met de open kaart.
 */
$("[data-accommodation-read-more]").on("click tap", function () {
    const $item = $(this).closest(".sb_accommodation-item");
    const isExpanded = !$item.hasClass("s_is-expanded");

    $item.toggleClass("s_is-expanded", isExpanded);

    $(this)
        .attr("aria-expanded", String(isExpanded))
        .text(
            isExpanded
                ? $(this).data("read-less-text")
                : $(this).data("read-more-text")
        );

    $(document).trigger("slider-cards:measure");
});

/**
 * Run on page load
 */
$(function () {
    const containers = document.querySelectorAll("[data-accommodations-items]");

    if (containers.length === 0) {
        return;
    }

    containers.forEach(syncSlider);

    IS_MOBILE.addEventListener("change", () => containers.forEach(syncSlider));

    // De regelval verandert met de kaartbreedte (81vw) en zodra de webfont binnen is, dus meet
    // opnieuw en trek de hoogtes daarna opnieuw gelijk.
    let resizeTimer = null;

    const remeasure = () => {
        containers.forEach(markClampedTexts);
        $(document).trigger("slider-cards:measure");
    };

    $(window).on("load", remeasure);
    $(window).on("resize orientationchange", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(remeasure, 150);
    });
});
